import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

import CareerHero from "../components/CareerPage/CareerHero";
import OurStory from "../components/CareerPage/OurStory";
import Boot41 from "../components/CareerPage/Boot41";
import Boot41FlowFrame from "../components/CareerPage/Boot41FlowFrame";
import JobOpening from "../components/CareerPage/JobOpening";
import WhatYouCanExpect from "../components/CareerPage/WhatYouCanExpect";
import LifeAtThink41 from "../components/CareerPage/LifeAtThink41";
import ellipse from "../assets/Career/Ellipse.svg";

const CareerPage2 = () => {
  const jobRef = useRef(null);
  const location = useLocation();

  // Smooth scroll if navigated with hash
  useEffect(() => {
    if (location.hash === "#jobs" && jobRef.current) {
      setTimeout(() => {
        jobRef.current.scrollIntoView({ behavior: "smooth" });
      }, 100); // small delay for smooth transition
    }
  }, [location]);

  return (
    <div>
      <CareerHero jobRef={jobRef} />
      <OurStory />
      <div ref={jobRef}>
        <JobOpening />
      </div>
      <WhatYouCanExpect />
      <div style={{ height: 16 }} />
      <LifeAtThink41 />
      {/* Ellipse Blur Divider - now before Boot41 */}
    </div>
  );
};

export default CareerPage2;
